export default {
  removeSelectedContentFromSession: () => {
    // Remove selected content from session on search page
    sessionStorage.removeItem('selectedContents')
  },

  removeContentViewFromSession: () => {
    // Remove selected content view session on search page
    sessionStorage.removeItem('selectedViewType')
  }
}
